import { jsx as _jsx } from "react/jsx-runtime";
import { getDeleteCourseMutationOptions, isLoading, useDeleteCourseMutation, } from 'api';
import { DeletionConfirmationDialog, LoadingWrapper } from 'components/custom';
import { enqueueSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
const DeleteCourseDialog = (props) => {
    const { courseToDelete, setCourseToDelete } = props;
    const { t } = useTranslation('timetable', {
        keyPrefix: 'steps.courses.cmp.DeleteCourseDialog',
    });
    const [deleteCourse, statusDeleteCourse] = useDeleteCourseMutation();
    const handleDelete = () => {
        if (courseToDelete?.id) {
            void deleteCourse(getDeleteCourseMutationOptions(courseToDelete.id)).then(() => {
                setCourseToDelete(null);
                enqueueSnackbar(t('successMessage'));
            });
        }
    };
    return (_jsx(DeletionConfirmationDialog, { open: !!courseToDelete?.id, onClose: () => {
            setCourseToDelete(null);
        }, titleProps: {
            text: t('title'),
        }, cancelButtonProps: {
            onClick: () => {
                setCourseToDelete(null);
            },
        }, confirmButtonProps: {
            children: t('actions.delete'),
            disabled: isLoading(statusDeleteCourse),
            onClick: handleDelete,
        }, children: _jsx(LoadingWrapper, { mutation: statusDeleteCourse, children: t('text', {
                name: courseToDelete?.name,
            }) }) }));
};
export default DeleteCourseDialog;
